import {
    FilterOp,
    useQueryPatientsOwnersQuery,
} from '~graphql/generated/graphql'
import { useDebounce } from './use-debounce'
import { PAGE_SIZES, PageSizeType } from '~config/constants'
import { usePageControls } from './use-page-controls'
import { eqBoolFilter, isNullFilter } from '~utils/query-helpers'
import { processSearchQuery } from '~utils/hooks/use-search-clients'
// Trigger build

type UseSearchClientsProps = {
    clinic:
        | {
              id: string
          }
        | undefined
    query: string
    showInactive?: boolean
}

export function useSearchPatients({
    clinic,
    query,
    showInactive,
}: UseSearchClientsProps) {
    const debouncedQuery = useDebounce(query, 500)

    const { page, setPage, pageSize, setPageSize } = usePageControls(
        PAGE_SIZES[1],
        JSON.stringify([query, showInactive]),
    )

    const { data, loading, error } = useQueryPatientsOwnersQuery({
        variables: {
            clinicId: clinic?.id || '',
            where: [
                {
                    column: 'vector_search_field',
                    filterOp: FilterOp.Fts,
                    value: {
                        string: processSearchQuery(debouncedQuery),
                    },
                },
                isNullFilter('patient_pms_id', true),
                ...(showInactive
                    ? []
                    : [
                          eqBoolFilter('patient_is_active', true),
                          eqBoolFilter('patient_is_deceased', false),
                      ]),
            ],
            page,
            pageSize,
        },
        skip: !clinic?.id || !debouncedQuery.trim(),
    })

    const patientResults =
        data?.queryPatientsOwners?.patients.filter(Boolean) || []

    const count = data?.queryPatientsOwners?.count || 0
    const isCountCapped = data?.queryPatientsOwners?.isCountCapped ?? false

    return {
        patientResults,
        loading,
        error,
        page,
        setPage,
        pageSize,
        setPageSize,
        count,
        isCountCapped,
    }
}
